import React from 'react';
import '../styles/GuestPrompt.css';

const GuestPrompt = ({ isOpen, onRegister, onDismiss }) => {
  if (!isOpen) return null;

  return (
    <div className="guest-prompt-overlay" onClick={onDismiss}>
      <div className="guest-prompt" onClick={(e) => e.stopPropagation()}>
        <div className="prompt-icon">🎮</div>
        <h2>Great Game!</h2>
        <p>You played as a guest. Create an account to:</p>
        <ul className="benefits-list">
          <li>✅ Save your game history</li>
          <li>✅ Track your progress</li>
          <li>✅ Compete on leaderboards</li>
          <li>✅ Unlock achievements</li>
        </ul>
        <div className="prompt-actions">
          <button className="register-btn" onClick={onRegister}>
            Create Account
          </button>
          <button className="dismiss-btn" onClick={onDismiss}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestPrompt;
